// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/builds/xiaoduo-front/xiaoduo-simulation-training/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/PageLoading/index';

export function getRoutes() {
  const routes = [
  {
    "name": "体验页",
    "path": "/experience",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__experience' */'@/pages/experience'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "name": "html预览",
    "path": "/htmlPreview",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__htmlPreview' */'@/pages/htmlPreview'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/user",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BlankLayout' */'/builds/xiaoduo-front/xiaoduo-simulation-training/src/layouts/BlankLayout'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/user",
        "redirect": "/user/login",
        "exact": true
      },
      {
        "name": "登录",
        "icon": "smile",
        "path": "/user/login",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__user__login' */'/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/user/login'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__exception__404' */'/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/exception/404'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  },
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'layouts__BasicLayout' */'/builds/xiaoduo-front/xiaoduo-simulation-training/src/layouts/BasicLayout'), loading: LoadingComponent}),
    "routes": [
      {
        "path": "/",
        "redirect": "/bank/story",
        "exact": true
      },
      {
        "name": "工作台",
        "path": "/workbench",
        "routes": [
          {
            "name": "首页",
            "icon": "icon-shouye",
            "path": "/workbench/dashboard",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__dashboard' */'/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/dashboard'), loading: LoadingComponent}),
            "hideHeader": true,
            "exact": true
          },
          {
            "name": "流量看板",
            "icon": "icon-shouye",
            "path": "/workbench/bill",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__bill' */'/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/bill'), loading: LoadingComponent}),
            "hideHeader": true,
            "hideInMenu": true,
            "exact": true
          },
          {
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__dataforceRender' */'/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/dataforceRender'), loading: LoadingComponent}),
            "exact": true
          }
        ]
      },
      {
        "name": "题库管理",
        "path": "/bank",
        "routes": [
          {
            "name": "AI 剧本",
            "icon": "icon-ai-juben",
            "path": "/bank/story",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__case__story' */'/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/case/story'), loading: LoadingComponent}),
            "hideHeader": true,
            "exact": true
          },
          {
            "name": "案例管理",
            "icon": "icon-anliguanli",
            "path": "/bank/case",
            "routes": [
              {
                "path": "/bank/case",
                "redirect": "/bank/case/dialog",
                "exact": true
              },
              {
                "name": "素材库",
                "path": "/bank/case/material",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__case__material' */'/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/case/material'), loading: LoadingComponent}),
                "exact": true
              },
              {
                "name": "案例库",
                "path": "/bank/case/dialog",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__case__dialog' */'/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/case/dialog'), loading: LoadingComponent}),
                "hideHeader": true,
                "exact": true
              }
            ]
          },
          {
            "name": "工具库",
            "icon": "icon-gongjuku",
            "path": "/bank/toolsPage",
            "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__toolsPage' */'/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/toolsPage'), loading: LoadingComponent}),
            "hideHeader": true,
            "exact": true
          }
        ]
      },
      {
        "name": "使用工具",
        "path": "/bank/toolsPage/useTools",
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'components__UseTools' */'@/components/UseTools'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "name": "组卷考试",
        "path": "/exam",
        "routes": [
          {
            "name": "接待室",
            "icon": "icon-jiedaishi",
            "path": "/exam/admit",
            "routes": [
              {
                "path": "/exam/admit",
                "redirect": "/exam/admit/train",
                "exact": true
              },
              {
                "name": "模拟接待",
                "path": "/exam/admit/train",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__admit__train' */'/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/admit/train'), loading: LoadingComponent}),
                "hideHeader": true,
                "exact": true
              },
              {
                "name": "接待记录",
                "path": "/exam/admit/information/",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__admit__information' */'/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/admit/information'), loading: LoadingComponent}),
                "hideHeader": true,
                "exact": true
              },
              {
                "name": "接待记录",
                "path": "/exam/admit/information/:id",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__admit__information' */'/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/admit/information'), loading: LoadingComponent}),
                "hideHeader": true,
                "hideInMenu": true,
                "exact": true
              },
              {
                "name": "接待详情",
                "path": "/exam/admit/details",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__admit__details' */'/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/admit/details'), loading: LoadingComponent}),
                "hideHeader": true,
                "exact": true
              }
            ]
          }
        ]
      },
      {
        "name": "系统设置",
        "path": "/system",
        "routes": [
          {
            "name": "基础设置",
            "icon": "icon-jichushezhi",
            "path": "/system/person",
            "routes": [
              {
                "name": "员工管理",
                "path": "/system/person/manage",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__person__manage' */'/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/person/manage'), loading: LoadingComponent}),
                "hideHeader": true,
                "exact": true
              },
              {
                "name": "用户组",
                "path": "/system/person/user",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__person__user' */'/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/person/user'), loading: LoadingComponent}),
                "hideHeader": true,
                "exact": true
              },
              {
                "name": "快捷短语",
                "path": "/system/person/shortcut",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__person__shortcut' */'/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/person/shortcut'), loading: LoadingComponent}),
                "hideHeader": true,
                "exact": true
              },
              {
                "name": "AI 导师评价方案",
                "path": "/system/person/appraise",
                "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__person__appraise' */'/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/person/appraise'), loading: LoadingComponent}),
                "hideHeader": true,
                "exact": true
              }
            ]
          }
        ]
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__dataforceRender' */'/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/dataforceRender'), loading: LoadingComponent}),
        "exact": true
      },
      {
        "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__exception__404' */'/builds/xiaoduo-front/xiaoduo-simulation-training/src/pages/exception/404'), loading: LoadingComponent}),
        "exact": true
      }
    ]
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
